<template>
  <div>
    <div class="text-h6 text--text mb-6">
      Вопросы и ответы
    </div>
    <v-expansion-panels multiple>
      <v-expansion-panel
        v-for="(faq, index) in CLUB_CARD_FAQ"
        :key="index"
      >
        <v-expansion-panel-header
          expand-icon="ui-icon-arrow-down"
          class="text-body-1 pl-4 pr-2"
        >
          {{ faq.title }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="text-body-1 mx-n2">
          {{ faq.sentences.join(' ') }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { CLUB_CARD_FAQ } from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/constants'

export default {
  name: 'ClubInfoModalExpansionPanels',
  data: () => ({
    CLUB_CARD_FAQ,
  }),
}
</script>
